import React, { useContext } from 'react';

import ChatChannelListContext from '../../../context/ChatChannelListContext';

import {
  StyledSearchBar,
} from './styles';
import texts from './texts.json';

const ChannelSearch = () => {
  const {
    searchTerm,
    setSearchTerm,
  } = useContext(ChatChannelListContext);

  return (
    <StyledSearchBar
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      clearSearch={() => setSearchTerm('')}
      placeholder={texts.searchChannelPlaceholder}
    />
  );
};

export default ChannelSearch;
